import GeocoderApp from 'features/geocoder/GeocoderApp';

const GeoCoderPage = () => <GeocoderApp />;

export default GeoCoderPage;

